import * as React from 'react';
const rowIndexContext = React.createContext(undefined);
export const tableRowIndexContextDefaultValue = undefined;
var _React_useContext;
export const useTableRowIndexContext = ()=>(_React_useContext = React.useContext(rowIndexContext)) !== null && _React_useContext !== void 0 ? _React_useContext : tableRowIndexContextDefaultValue;
export const TableRowIndexContextProvider = rowIndexContext.Provider;
